module.exports = __webpack_public_path__ + "img/logo.36c13312.png";